import React from 'react';
import { useVendorAgreementParticipantsCols } from '../hooks/VendorCols';
import DashboardAthenaTable from './DashboardAthenaTable';

export default function VendorAgreementParticipants(props) {
  const vendorAgreementParticipantsCols = useVendorAgreementParticipantsCols();

  return (
    <>
        <DashboardAthenaTable
            {...props}
            params={{ ...props.headers }}
            tableColumns={vendorAgreementParticipantsCols}
            reportParamName={'po_vendor_agreement_participants'}
            reportName={'po_vendor_agreement_participants'}
            tableTitle={''} 
            callback={()=>{}}
            downloadFileName={`Vendor_Agreement_Participants_Download`}
        />
    </>
  );
}
